import { useUserPermission } from '@/lib/auth';
import { Globe, Users } from 'lucide-react';
import { useState } from 'react';
import { tv } from 'tailwind-variants';

const toggleButton = tv({
  base: 'flex items-center gap-2 rounded-full px-4 py-1.5 text-sm',
  variants: {
    isActive: {
      true: 'bg-primary-teal text-white [&>svg]:text-white',
      false: 'text-rw-dark-gray hover:bg-gray-100 [&>svg]:text-rw-dark-gray',
    },
  },
});

export const AppToggle = () => {
  const [isLounge, setIsLounge] = useState(false);
  const { isOnlyEduLicense } = useUserPermission();

  // 教育機関向けプランの場合は、SGLは非表示
  if (isOnlyEduLicense) return null;

  const handleLoungeClick = () => {
    setIsLounge(true);

    const dolphinUrl = import.meta.env.VITE_DOLPHIN_URL;
    window.location.href = dolphinUrl;
  };

  return (
    <div className="flex h-9 items-center justify-center rounded-full bg-white p-0.5">
      <div className={toggleButton({ isActive: !isLounge })}>
        <Globe className="size-5" />
        RuleWatch
      </div>
      <button
        onClick={handleLoungeClick}
        className={toggleButton({ isActive: isLounge })}
      >
        <Users className="size-5" />
        Lounge
      </button>
    </div>
  );
};
